import React from 'react';
import styled from 'styled-components';

import { ButtonPrimary } from '@yuhu-inc/yuhui';
import { InputNumber } from '@yuhuinc/ui-library';
import Row from 'components/ui/Row';
import Col from 'components/ui/Col';
import Spacer from 'components/ui/Spacer';
import AntdForm from 'components/ui/Form';
import TextBox from 'components/ui/TextBox';

import { colors } from 'helpers/ColorHelper';
import { getTranslatedString } from 'helpers/i18n';
import { extractSuffix, ADDITIONAL_CHARGES } from 'helpers/DocumentTemplateHelper';
import { sizes } from 'helpers/MediaHelper';

const StyledFieldCardContainer = styled.div`
  width: 100%;
  margin-top: 15px;
  background-color: ${colors.WHITE};
  border-radius: 16px;
  padding: 24px 24px 0px;
`;

const FullWidthText = styled(TextBox)`
  width: 100%;
`;

const FullWidthInputNumber = styled(InputNumber)`
  width: 100%;
`;

const StyledFieldCardCTAContainer = styled.div`
  border-top: 1.5px solid ${colors.PALE_GREY};
  margin-left: 12px;
  margin-right: 12px;
  display: flex;
  justify-content: flex-end;
  padding-top: 5px;
`;

const StyledCtaHR = styled.div`
  border-left: 1px solid ${colors.PALE_GREY};
`;

const StyledCta = styled(ButtonPrimary)`
  background-color: transparent !important;
  font-size: 16px;
`;

const AdditionalCharge = ({
  additionalCharge,
  values,
  setFieldValue,
  index,
  errors,
  handleRemoveField,
  documentTemplateTitle,
}) => {
  const errorCheck = errors['additional_charges'] && errors['additional_charges'][index];

  const isMobile = window.matchMedia(`(max-width: ${sizes.mobile}px)`).matches;

  // Dollar formatter and parser from ui-library/components/InputNumber stories
  const inputFormatter = (value) => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  const inputParser = (value) => value.replace(/\$\s?|(,*)/g, '');

  return (
    <StyledFieldCardContainer>
      <Spacer mb={1}>
        <Row gutter={16}>
          <Col span={24}>
            <AntdForm.Item
              label={getTranslatedString('landlordPortal.documentTemplate.chargeName')}
              validateStatus={errorCheck?.name && 'error'}
              help={errorCheck?.name}
            >
              <FullWidthText
                placeholder={getTranslatedString('landlordPortal.maintenance.placeHolder.enter')}
                size="large"
                value={extractSuffix(
                  additionalCharge.name,
                  ADDITIONAL_CHARGES,
                  documentTemplateTitle
                )}
                onChange={(e) => {
                  setFieldValue(`focusIndex`, index);
                  setFieldValue(`additional_charges[${index}].name`, e.target.value);
                }}
              />
            </AntdForm.Item>
          </Col>
        </Row>
      </Spacer>
      <Spacer mb={1}>
        <Row gutter={16}>
          <Col span={14}>
            <AntdForm.Item
              label={getTranslatedString('landlordPortal.documentTemplate.defaultValue')}
              validateStatus={errorCheck?.default_amount && 'error'}
              help={errorCheck?.default_amount}
            >
              <FullWidthInputNumber
                placeholder={getTranslatedString('landlordPortal.maintenance.placeHolder.enter')}
                value={additionalCharge.default_amount}
                formatter={inputFormatter}
                parser={inputParser}
                onChange={(value) =>
                  setFieldValue(`additional_charges[${index}].default_amount`, value)
                }
                isMobile={isMobile}
              />
            </AntdForm.Item>
          </Col>
        </Row>
      </Spacer>

      <Spacer mb={1}>
        <Row gutter={24}>
          <StyledFieldCardCTAContainer>
            <StyledCtaHR />
            <StyledCta
              type="button"
              contentKey="landlordPortal.documentTemplate.delete"
              onClick={() => handleRemoveField(values, index, setFieldValue)}
            />
          </StyledFieldCardCTAContainer>
        </Row>
      </Spacer>
    </StyledFieldCardContainer>
  );
};

export default AdditionalCharge;
